
import { default as AnswerEditor } from "../vue/editors/answer.vue";
import { default as AnswerPreview } from "../vue/previews/answer.vue";
export const Answer = {
	icon: "mdi.card-text",
	editor: AnswerEditor,
	preview: AnswerPreview,
	factory(){
		return {};
	}
};

import { default as CheckboxesEditor } from "../vue/editors/checkboxes.vue";
import { default as CheckboxesPreview } from "../vue/previews/checkboxes.vue";
export const Checkboxes = {
	icon: "mdi.check-box-outline",
	editor: CheckboxesEditor,
	preview: CheckboxesPreview,
	factory(){
		return {
			options: [ "" ]
		};
	}
};

import { default as MultipleChoiceEditor } from "../vue/editors/multiple-choice.vue";
import { default as MultipleChoicePreview } from "../vue/previews/multiple-choice.vue";
export const MultipleChoice = {
	icon: "mdi.radiobox-marked",
	editor: MultipleChoiceEditor,
	preview: MultipleChoicePreview,
	factory(){
		return {
			options: [ "" ]
		};
	}
};

import { default as DropdownEditor } from "../vue/editors/dropdown.vue";
import { default as DropdownPreview } from "../vue/previews/dropdown.vue";
export const Dropdown = {
	icon: "mdi.chevron-down-box",
	editor: DropdownEditor,
	preview: DropdownPreview,
	factory(){
		return {
			options: [ "" ]
		};
	}
};

import { default as LinearScaleEditor } from "../vue/editors/linear-scale.vue";
import { default as LinearScalePreview } from "../vue/previews/linear-scale.vue";
export const LinearScale = {
	icon: "mdi.electric-switch-closed",
	editor: LinearScaleEditor,
	preview: LinearScalePreview,
	factory(){
		return {
			label: "",
			columns: [ "", "", "" ],
			rows: [ "" ]
		};
	}
};

import { default as InformationEditor } from "../vue/editors/information.vue";
import { default as InformationPreview } from "../vue/previews/information.vue";
export const Information = {
	icon: "mdi.information",
	editor: InformationEditor,
	preview: InformationPreview,
	factory(){
		return {
			title:"",
			text:""
		}
	}
};

import { default as HTMLEditor } from "../vue/editors/html.vue";
import { default as HTMLPreview } from "../vue/previews/html.vue";
export const HTML = {
	icon: "mdi.code-tags",
	editor: HTMLEditor,
	preview: HTMLPreview,
	factory(){
		return {
			content:""
		};
	}
};


import { default as DefaultEditor } from "../vue/editors/default.vue";
import { default as DefaultPreview } from "../vue/previews/default.vue";
export const Default = {
	icon: "",
	editor: DefaultEditor,
	preview: DefaultPreview,
	disabled:true
};